import React from 'react';

function NotificationsIcon() {
  return (
    <svg className="notifications-icon" viewBox="0 0 73 82" xmlns="http://www.w3.org/2000/svg">
      <title>Notifications</title>
      <g fill="none" fillRule="evenodd" transform="translate(0 2)">
        <path fill="#1B3C7B" d="M47.68 16.512H4.947C2.35 16.512 0 19.092 0 21.735v53.172C0 77.553 2.35 80 4.947 80H47.68c2.6 0 5.008-2.447 5.008-5.093V21.735c0-2.644-2.407-5.223-5.008-5.223zM10.085 67.304h32.463v-4.17H10.085v4.17zm0-10.52h32.463v-4.298H10.085v4.3zm38.612 16.933c0 1.984-1.332 2.117-1.84 2.117H5.837c-.574 0-1.84-.133-1.84-2.117V33.44h44.7v40.277zm-38.612-27.51h32.463v-4.302H10.085v4.3z"/>
        <ellipse cx="51.739" cy="19.686" fill="#DD2E2E" stroke="#FFF" strokeWidth="4.5" rx="18.261" ry="19.047"/>
      </g>
    </svg>
  );
}

export default NotificationsIcon;



// WEBPACK FOOTER //
// ./modules/Common/components/svg/NotificationsIcon.js